<template>
  <div class="row">
    <edit-bot-client-btn v-if="details" :show="showEdit" @close="showEdit=false" :form-details="editPayload"/>
    <card v-loading="loading" :title="$t('botClients.pageSingle.title')" class="col-xl-6">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <bot-client-details :details="details"/>
         <div class="button-container mt-3">
          <div class="row">
            <div class="col-6" v-if="$auth.can({fare_group: 'update'}, 'permissions')">
              <el-tooltip :content="$t('fareGroup.editBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom">
                <base-button block type="info" class="btn pr-3 pl-2" @click.native="handleEdit()">
                  <i class="tim-icons icon-pencil pr-2"/>{{ $t('fareGroup.editBtnLabel') }}
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-6" v-if="$auth.can({fare_group: 'delete'}, 'permissions')">
              <el-tooltip :content="$t('fareGroup.deleteBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom">
                <base-button block type="danger" class="btn pr-3 pl-2" @click.native="handleDelete()">
                  <i class="tim-icons icon-simple-remove pr-2"/> {{ $t('fareGroup.deleteBtnLabel') }}
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
    </span>
    </card>
  </div>
</template>
<script>
import BotClientDetails from "src/components/BotClient/BotClientDetails";
import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";
import EditBotClientBtn from "@/pages/BotClients/EditBotClientBtn";

export default {
  name: 'BotClientPage',
  components: {
    BotClientDetails,
    EditBotClientBtn
  },
  data: () => ({
    showEdit: false,
    editPayload: {},
  }),
  methods: {
    ...mapActions(['LoadBotClient', 'DeleteBotClient', 'RemoveMunicipalityBotClient']),
    handleEdit() {
      this.editPayload = Object.assign({}, this.details);
      this.showEdit = true;
    },
    handleDelete(index, row) {
      swal({
        text: `'${this.details.name}'`,
        title: this.$t('botClients.delete.text'),
        confirmButtonText: this.$t('botClients.delete.actionBtnLabel'),
        cancelButtonText: this.$t('botClients.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          // Copy details.
          const copy = Object.assign({}, this.details);
          this.DeleteBotClient(copy).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('botClients.delete.deletedNotification', {name: copy.name}),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.$router.back()
            }

          })
        }
      });
    },
  },
  computed: {
    ...mapState({
      updating: state => state.bot_client.updating,
      loading: state => state.bot_client.loading,
      details: state => state.bot_client.data,
      error: state => state.bot_client.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadBotClient({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
